import { gql } from "graphql-tag";

import { documentLink, collectionLink } from "~/app/prismic/prismic-fragments";

export const getTopCategoryV2 = (pageType, isNewSliceType = false) => {
  const typePrefix = `${pageType}${isNewSliceType ? "Slices" : "Body"}`;

  return gql`
    fragment ${pageType}_top_category_v2 on ${typePrefix}Top_category_v2 {
      type
      label
      variation {
        ... on ${typePrefix}Top_category_v2Default {
          primary {
            title
          }
          items {
            link {
              ... documentLink
              ... collectionLink
            }
          }
        }
      }
    }
  ${documentLink}
  ${collectionLink}`;
};
